import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type WorkspaceCollaboratorItemFragment = (
  { __typename: 'Collaborator' }
  & Pick<Types.Collaborator, 'id' | 'activityBlocked' | 'boardCount' | 'dateLastImpression' | 'fullName' | 'idEnterprise' | 'username'>
  & { nonPublic?: Types.Maybe<(
    { __typename: 'Member_NonPublic' }
    & Pick<Types.Member_NonPublic, 'fullName'>
  )> }
);

export const WorkspaceCollaboratorItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkspaceCollaboratorItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Collaborator' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'boardCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateLastImpression' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idEnterprise' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nonPublic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'username' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseWorkspaceCollaboratorItemFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      WorkspaceCollaboratorItemFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseWorkspaceCollaboratorItemFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<WorkspaceCollaboratorItemFragment>,
    'data'
  > {
  data?: WorkspaceCollaboratorItemFragment;
}

export const useWorkspaceCollaboratorItemFragment = ({
  from,
  returnPartialData,
  ...options
}: UseWorkspaceCollaboratorItemFragmentOptions): UseWorkspaceCollaboratorItemFragmentResult => {
  const result = Apollo.useFragment<WorkspaceCollaboratorItemFragment>({
    ...options,
    fragment: WorkspaceCollaboratorItemFragmentDoc,
    fragmentName: 'WorkspaceCollaboratorItem',
    from: {
      __typename: 'Collaborator',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as WorkspaceCollaboratorItemFragment };
};
